import React, { useState } from 'react';
import { DisplayStart, FormControl, SearchInput, TemplateListBox, TemplateMainCategory, TemplateSize, TemplateSubCategory } from '../StyledComponents';
import { Grid } from '@mui/material';
import SimpleSelect from '../SimpleSelectWithCheck';
import styled from "styled-components"
import {ChromePicker} from 'react-color';


const TabWrapper = styled.div`
background: rgba(226, 243, 254, 1);
padding:8px;
border-radius:5px;
display:flex;
`
const TabButton = styled.div`
flex:1;
text-align:center;
padding:10px;
border-radius:5px;
cursor:pointer;
&.active{
    background:rgba(255, 255, 255, 1);

}
`
const TabContent = styled.div`
& .w-100 .chrome-picker{
    width:100% !important;
}
& .w-100 .chrome-picker .saturation-white > div > div{
    background-color:#fff;
    width:18px !important;
    height:18px !important;
    border-radius: 50% !important;
}
`


const SelectData = [
    { title: 'Color'},
    { title: 'Photo' },
    { title: 'Standard from template' },
  ];


function EditBackground(props) {
    const [ColorTab, setColorTab] = useState('solid');
    const [selectedOpt, SelectedOpt] = useState('');
    return (
        <>
            <div className="px-10px" style={{paddingBottom:"15px"}}>
                <DisplayStart>
                    <SimpleSelect onChange={(selected) => {debugger; SelectedOpt(selected?.title)}} optiopnList={SelectData}/>
                </DisplayStart>
            </div>
            <div>
                <TabWrapper>
                    <TabButton onClick={() => setColorTab('solid')} className={ColorTab === 'solid' && 'active'}>
                        Solid
                    </TabButton>
                    <TabButton onClick={() => setColorTab('gradient')} className={ColorTab !== 'solid' && 'active'}>
                        Gradient
                    </TabButton>
                </TabWrapper>
                <TabContent>
                    {selectedOpt === 'Color' && <div>
                    {ColorTab === 'solid' && <SolidTab />}
                    {ColorTab !== 'solid' && <GradientTab />}
                    </div>
                    }
                </TabContent>
            </div>
        </>
    );
}

export default EditBackground;


function SolidTab() {
    const [color, setColor] = useState('rgba(255,255,255,1)');
    const handleChangeComplete=(color)=>{
        debugger
        setColor(`rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`);
    }
    return (
        <div className='w-100'>
            <ChromePicker 
                color={color}
                onChange={handleChangeComplete}
             />
        </div>
    );
}
function GradientTab() {
    const [color, setColor] = useState('rgba(0,0,0,1)');
    const handleChangeComplete=(color)=>{
        debugger
        setColor(`rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`);
    }
    return (
        <div className='w-100'>
            <h1>GradeitnTab</h1>

            {/* <ChromePicker 
                color={color}
                onChange={handleChangeComplete}
             /> */}
        </div>
    );
}
